import { useEffect, useState } from "react";
import { callIcon } from "../database/ExportAssets";
import deleteIcon from "../assets/icons/delete_num.png";
import { formatDate } from "../utils/Helpers";
import { Alert } from "./index";
import { useCallContext } from "../callContext/callContext";
import { useMainContext } from "../callContext/MainContext";
import {DialerText as text} from "../database/Text";
const Dailer = () => {
  const [number, setNumber] = useState("");
  const { callInfoApi, callsList, setCallsList } =
    useCallContext();
  const {language}=useMainContext();
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedAvatar, setSelectedAvatar] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const numList = [
    {
      id: 1,
      icon: require("../assets/icons/1.png"),
      num: "1",
    },
    {
      id: 2,
      icon: require("../assets/icons/2.png"),
      num: "2",
    },
    {
      id: 3,
      icon: require("../assets/icons/3.png"),
      num: "3",
    },
    {
      id: 4,
      icon: require("../assets/icons/4.png"),
      num: "4",
    },
    {
      id: 5,
      icon: require("../assets/icons/5.png"),
      num: "5",
    },
    {
      id: 6,
      icon: require("../assets/icons/6.png"),
      num: "6",
    },
    {
      id: 7,
      icon: require("../assets/icons/7.png"),
      num: "7",
    },
    {
      id: 8,
      icon: require("../assets/icons/8.png"),
      num: "8",
    },
    {
      id: 9,
      icon: require("../assets/icons/9.png"),
      num: "9",
    },
    {
      id: 10,
      icon: require("../assets/icons/+.png"),
      num: "+",
    },
    {
      id: 11,
      icon: require("../assets/icons/0.png"),
      num: "0",
    },
  ];

  useEffect(() => {
    if (number.length > 0) {
      setIsDisabled(false);
    }
  }, [number]);
  useEffect(() => {
    window.scrollTo(0, 0);
    const selectedAvatar = localStorage.getItem("currentSelectedAvatar")
      ? JSON.parse(localStorage.getItem("currentSelectedAvatar"))
      : [];
    setSelectedAvatar(selectedAvatar);
  }, []);
  const handleCallClick = (e) => {
    e.preventDefault();
    if (!isDisabled && number.length < 5) {
      setAlertMessage(text?.minLengthText?.[language]);
      setShowAlert(true);
    } else if (number.length > 15) {
      setAlertMessage(text?.maxLengthText?.[language]);
      setShowAlert(true);
    } else if (!isDisabled) {
      console.log("Call button clicked");

      callInfoApi(selectedAvatar, number, "Dailer");
      const newCall = {
        call: {
          phone: number,
          name: "",
          time: formatDate(new Date()),
        },
        avatar: selectedAvatar,
      };
      setCallsList((oldList) => [newCall, ...oldList]);
    }
    //  if(isDisabled)
    else {
      setAlertMessage(text?.noNumText?.[language]);
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (callsList.length > 10) {
      console.log(callsList);
      const cpyArray = [...callsList];
      cpyArray.splice(10, 1);
      console.log("list is:::", cpyArray);
      setCallsList(cpyArray);
    }
    localStorage.setItem("callsList", JSON.stringify(callsList));
  }, [callsList]);

  const handleDeleteDigit = (e) => {
    e.preventDefault();
    console.log("delete digit button clicked");
    setNumber(number.slice(0, -1));
  };
  const handleNumClick = (num) => {
    let numm = number.concat(num);
    setNumber(numm); //to remove the leading
  };
  
  useEffect(() => {
    if (number.length > 15) {
      setAlertMessage(text?.maxLengthText[language]);
      setShowAlert(true);
    }
  }, [number]);
  
  return (
    <>
         <div className="pt-2 h-screen fixed  w-full max-w-[500px]  mt-2 fadeInOut ">
        <div className="h-[70%] flex flex-col justify-around items-center ">
          <div className="flex py-8  w-full px-4">
            <div className=" flex justify-center items-center bg-transparent focus:outline-none w-10/12 m-auto text-xl break-all text-center ">
              <input
                type="text"
                value={number}
                className="w-full outline-none text-center text-2xl font-extrabold"
                maxLength={16}
                onChange={(e) => setNumber(e.target.value)}
              />
            </div>
            <img
              src={deleteIcon}
              className=" m-auto cursor-pointer"
              onClick={handleDeleteDigit}
            />
          </div>
          <div className="grid grid-cols-3  mx-4  w-3/4 ">
            {numList &&
              numList.map((item) => {
                return (
                  <div
                    key={item.id}
                    className="box-shadow mb-4 cursor-pointer"
                    onClick={() => handleNumClick(item.num)}
                    value={item.num}
                  >
                    <img
                      src={item.icon}
                      alt={item.id}
                      className="m-auto h-14"
                    />
                  </div>
                );
              })}
            <div
              className="rounded-full cursor-pointer "
              onClick={handleCallClick}
            >
              <img src={callIcon} alt="callIcon" className="m-auto h-16" />
            </div>
          </div>
        </div>
      </div>
      <>{/* <Calling callDetials={callDetials} /> */}</>

      {showAlert && (
        <Alert
          showAlert={showAlert}
          handleOkClick={() => setShowAlert(false)}
          message={alertMessage}
        />
      )}
    </>
  );
};

export default Dailer;
